export const displayName = (separator, ...parameters) => parameters.filter((x) => x != null).join(separator)

export const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component'
